<template>
    <div class="statis-view">
        <a-row :gutter="15">
            <a-col span="10">
                <a-row :gutter="15">
                    <a-col span="12">
                        <a-card>
                            <a-statistic title="占用空间" :value="storageBytes"/>
                        </a-card>
                    </a-col>
                    <a-col span="12">
                        <a-card>
                            <a-statistic title="打赏总额" :value="rewardAmount"/>
                        </a-card>
                    </a-col>
                </a-row>
            </a-col>
            <a-col span="14">
                <a-card>
                    <a-card-grid :hoverable="false">上传：{{data["photo_total"] || 0}} 张</a-card-grid>
                    <a-card-grid :hoverable="false">发布：{{data["photo_release"] || 0}} 张</a-card-grid>
                    <a-card-grid :hoverable="false">原图：{{data["photo_origin"] || 0}} 张</a-card-grid>
                    <a-card-grid :hoverable="false">收藏：{{data["star_num"] || 0}} 张</a-card-grid>
                    <a-card-grid :hoverable="false">打赏：{{data["reward_num"] || 0}} 张</a-card-grid>
                    <a-card-grid :hoverable="false">下载：{{data["download_num"] || 0}} 张</a-card-grid>
                </a-card>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="members" v-if="members.length" row-key="id" :bordered="true" :pagination="false"/>
    </div>
</template>

<script>
    import api from "../../../../utils/api";
    import func from "../../../../utils/func";
    import cache from "../../../../utils/cache";
    import enums from "../../../../utils/enums";

    export default {
        name: "StatisView",
        props: {albumId: String},
        data() {
            return {
                data: {},
                members: [],
                columns: [
                    {title: "成员昵称", dataIndex: "nick"},
                    {title: "上传数量", dataIndex: "photo_total"},
                    {title: "发布数量", dataIndex: "photo_release"},
                    {title: "原图数量", dataIndex: "photo_origin"},
                    {title: "收藏数量", dataIndex: "star_num"},
                    {title: "下载数量", dataIndex: "download_num"},
                    {title: "打赏数量", dataIndex: "reward_num"},
                    {
                        title: "打赏金额",
                        dataIndex: "reward_amount",
                        customRender: (value) => func.formatCNF(value)
                    }
                ]
            }
        },
        async mounted() {
            this.data = await api.v1.album.stats.album(this.albumId);
            let res = await cache.v1.album.member.names(this.albumId, enums.Role.Grapher);
            let stats = await api.v1.album.stats.member(this.albumId, func.mapKeys(res).join(","));
            for (let id in stats) {
                this.members.push(Object.assign(stats[id], {id: id, nick: res[id]}));
            }
        },
        computed: {
            rewardAmount() {
                let value = func.isDefined(this.data["reward_amount"])
                    ? this.data["reward_amount"] : 0;
                return func.formatCNF(value);
            },
            storageBytes() {
                let value = func.isDefined(this.data["storage_kb"])
                    ? this.data["storage_kb"] : 0;
                return func.bytesAuto(value * 1024);
            }
        }
    }
</script>

<style scoped lang="less">
    .statis-view {
        .ant-card {
            margin-bottom: 15px;
        }

        .ant-card-grid {
            padding: 13px 16px;
        }

        .ant-table-wrapper {
            background: #ffffff;
            margin-bottom: 15px;
            border-radius: 4px;
        }
    }
</style>
